import React from "react";
import { Link } from "react-router-dom";

const PORTRAIT = "https://images.unsplash.com/photo-1646227655718-dd721b681d91";
const TX = "https://images.pexels.com/photos/34410302/pexels-photo-34410302.jpeg";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0" style={{ backgroundImage: `url(${TX})`, backgroundSize: "cover", backgroundPosition: "center", opacity: 0.4 }} />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/70 via-[#0a0a0b]/80 to-[#0a0a0b]" />
        <div className="relative mx-auto max-w-[1400px] px-6 py-24 lg:px-10 lg:py-32">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFB800]">About</div>
          <h1 className="mt-4 font-display text-5xl font-black uppercase leading-none text-white sm:text-7xl lg:text-8xl">
            Four decades<br />in the dirt.
          </h1>
          <p className="mt-8 max-w-2xl text-base text-white/80 sm:text-lg">
            Texas Iron was founded in Houston in 1987 by two brothers who grew up running dozers on their grandfather's ranch. What started as a single-lot operation has grown into one of the Lone Star State's most trusted heavy equipment dealers — still family-owned, still answering our own phones.
          </p>
        </div>
      </section>

      <section className="mx-auto grid max-w-[1400px] gap-16 px-6 py-24 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <div className="overflow-hidden border border-[#27272A]">
            <img src={PORTRAIT} alt="Ironworker" className="h-full w-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFB800]">Our Principles</div>
          <h2 className="mt-4 font-display text-4xl font-black uppercase leading-none sm:text-5xl">
            Honest iron. No surprises.
          </h2>
          <div className="mt-10 space-y-8">
            {[
              { n: "01", t: "Every machine inspected", b: "Our factory-trained techs run a 120-point inspection, oil analysis, and road test on every used machine before it hits the lot." },
              { n: "02", t: "Transparent history", b: "Full service records, hour-meter verification, and photos of wear points — in writing, before you buy." },
              { n: "03", t: "No-drama warranty", b: "30-day powertrain warranty on all used machines. Extended coverage available. Claims handled in-house." },
              { n: "04", t: "Nationwide delivery", b: "Flatbed, lowboy, and RGN carriers ship to all 50 states. Texas-based, U.S.-wide — usually on the road within 5 business days." },
            ].map((p) => (
              <div key={p.n} className="grid grid-cols-[auto_1fr] gap-6 border-b border-[#27272A] pb-8">
                <div className="font-display text-4xl font-black text-[#FFB800]">{p.n}</div>
                <div>
                  <h3 className="font-display text-xl font-bold uppercase">{p.t}</h3>
                  <p className="mt-2 text-sm text-white/60">{p.b}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#0a0a0b]">
        <div className="mx-auto grid max-w-[1400px] gap-px border border-[#27272A] bg-[#27272A] lg:grid-cols-4">
          {[
            { k: "38", l: "Years in Business" },
            { k: "4,200+", l: "Machines Sold" },
            { k: "50", l: "States Delivered" },
            { k: "12", l: "Financing Partners" },
          ].map((s, i) => (
            <div key={i} className="bg-[#0a0a0b] p-10 text-center">
              <div className="font-display text-5xl font-black text-[#FFB800] sm:text-6xl">{s.k}</div>
              <div className="mt-3 font-mono text-xs uppercase tracking-[0.3em] text-white/60">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 py-24 text-center lg:px-10">
        <h2 className="mx-auto max-w-3xl font-display text-4xl font-black uppercase leading-none sm:text-6xl">
          Need a machine? We've got <span className="text-[#FFB800]">iron ready.</span>
        </h2>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/inventory" className="bg-[#FFB800] px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-black hover:bg-[#E5A600]">Browse Inventory</Link>
          <Link to="/contact" className="border border-white/20 px-8 py-4 font-display text-sm font-bold uppercase tracking-widest hover:border-[#FFB800] hover:text-[#FFB800]">Talk to a Dealer</Link>
        </div>
      </section>
    </div>
  );
}
